import {useCallback} from 'react'
import useMessage from '@hooks/useMessage'
import {useMutation} from 'apollo-hooks'
import gql from 'graphql-tag'
import {useRouter} from 'next/router'

export default function useReorder() {
  const router = useRouter()
  const orderId = router.query.orderId as string
  const showMessage = useMessage()

  const mutate = useMutation(gql`
    mutation TrackingV2RepeatOrder($orderId: ID) {
      repeatOrder(orderId: $orderId)
    }
  `)

  const repeatOrder = useCallback(async () => {
    try {
      await mutate({orderId})
      await router.push('/checkout')
    } catch (error) {
      showMessage(error)
    }
  }, [orderId])

  return repeatOrder
}
